<div class=upcoming class:current={view.persona.ID === upcoming.subject} style="background-color: {calc_color(upcoming)}">
	<!-- 1st line: time, ID of subject and action -->
	<div class=tick-time title={upcoming.ID}>{timestamp(upcoming.time)}</div>
	<div class=tick-char onclick={() => view.select_persona(upcoming.subject)}>{upcoming.subject}</div>
	<div class={upcoming.ZUB} onmouseenter={show_action.bind(upcoming.action)} onmouseleave={unshow_action}>{upcoming.action}</div>
	<div class=tick-char>{(typeof upcoming.target === 'object' && upcoming.target !== null) ? upcoming.target.str : upcoming.target ?? ""}</div>
	<!-- 2nd line (only for master): text -->
	{#if user.isMaster}
		<div class="review tick-double" title="{upcoming.evaluation}">{upcoming.text}</div>
		{#if upcoming.ZUB === 'Inspect'}
			<div class="review tick-double">Reaktion genehmigen?</div>
		{/if}
	{/if}
</div>


<script>
    import { user, game, view } from "../client.svelte.js";
    import {impactHue, timestamp} from "../core.js";
		import {show_actionCard, close_actionCard} from "../dialogs/OptionDialog.svelte";

    let { upcoming } = $props();
		let text = $derived((upcoming.text) ? upcoming.text :
			(upcoming.ZUB === 'Incept')  ? `${upcoming.subject} startet Handlung ${upcoming.action}` :
		  (upcoming.ZUB === 'Inspect') ? `${upcoming.subject} will Handlung ${upcoming.action} starten. OK?` :
			(upcoming.ZUB === 'Insight') ? `${upcoming.subject} führt Handlung ${upcoming.action} aus` : "" )
    let chance = $derived((user.isMaster && upcoming.rolled && upcoming.acttype !== 'Performance') ? upcoming.rolled.split("||")[0] : "")
		// $inspect(`UPCOMING - incident`, upcoming)

    function calc_color(incid) {
        /** colors the specific activity according to type, strength and target (exclamation mark for hitting comrades) */
        if (incid.ZUB !== 'Inflict' || incid.force === 0) return
        /// calculate strength and scale it down if further in future and not master
        const alpha = Math.round((user.isMaster) ? 100 : 100 - Math.min(incid.time - game.time, 10) * 10)
        const sat = (incid.kind) ? 70 : 0
        const lum = (incid.force > 0) ? Math.round(incid.force * 10) : (incid.force < -2) ? 80 : 0
        return (incid.kind) ? `hsl(${impactHue[incid.kind]} ${sat}% ${lum}% / ${alpha}%)` : 'grey'
	}

		let timer

		function show_action(e) {
				e.stopPropagation()
				if (this)
					timer = setTimeout(() => show_actionCard(this, 'map'), 500)  }

		function unshow_action(e) {
				e.stopPropagation()
				clearTimeout(timer)
				if (view.option)
						close_actionCard()  }

</script>


<style lang="sass">
	.upcoming
		margin: 12px 6px
		display: grid
		grid-template-columns: 4ch 4ch 3fr 2fr
		/*justify-content: center*/
		grid-gap: 5px
		row-gap: 0

	.upcoming.current
		font-weight: bold

	.tick-time
		grid-column: 1

	.tick-char
		justify-self: center

	.tick-double
		grid-column: 3 / span 2

</style>